import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * Glosario de los totales de cobranza y liquidación.
 *
 * Existe porque los números se parecen entre sí y no son intercambiables:
 * "Total devengado" cuenta sólo lo vencido, "Total a cobrar" incluye lo que
 * todavía no venció, y los totales de liquidación se miden sobre todos los
 * períodos del filtro. Sin esta aclaración es fácil restar dos de ellos y
 * sacar una conclusión equivocada.
 *
 * Se abre desde el icono de información de cualquiera de las dos tarjetas y
 * arranca posicionado en la sección desde la que se lo llamó.
 */
@Component({
  selector: 'app-dialog-ayuda-totales',
  templateUrl: './dialog-ayuda-totales.component.html',
  styleUrls: ['./dialog-ayuda-totales.component.css']
})
export class DialogAyudaTotalesComponent {

  /** 'inquilino' | 'propietario'. Define qué sección se muestra expandida primero. */
  seccion: string = 'inquilino';

  constructor(
    public dialogRef: MatDialogRef<DialogAyudaTotalesComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.seccion)
      this.seccion = data.seccion;
  }

  cerrar() {
    this.dialogRef.close();
  }
}
